// extracted by mini-css-extract-plugin
export default {"nav":"PoliciesLayout_nav__OVZ+a","nav__link":"PoliciesLayout_nav__link__F1A8A"};